function preventScroll() {
	return {
		restrict: "A",

		scope: {
			preventScroll: "="
		},

		link: function(scope) {
			scope.$watch("preventScroll", function(shouldPreventScroll) {
				if(shouldPreventScroll) {
					document.documentElement.style.overflow = "hidden";
					document.body.style.overflow = "hidden";
					
					const contentSection = document.querySelector("#content");
					if(contentSection) {
						contentSection.style.overflow = "hidden";
					}
				} else {
					document.documentElement.style.overflow = "";
					document.body.style.overflow = "";
					const contentSection = document.querySelector("#content");
					if(contentSection) {
						contentSection.style.overflow = "";
					}
				}
			});
		},

		unlink: function() {
			document.documentElement.style.overflow = "";
			document.body.style.overflow = "";
			const contentSection = document.querySelector("#content");
			if(contentSection) {
				contentSection.style.overflow = "";
			}
		}
	};
}

export default angular
	.module("vesl.behaviors.prevent-scroll", [])
	.directive("preventScroll", preventScroll).name;
